export enum Routes {
  Main = 'main',
  Cart = 'cart',
  OrderDetails = 'order_details',
  Checkout = 'checkout',
  UploadGoogleReview = 'upload_google_review',
  RewardDetails = 'reward_details',
  Rewards = 'rewards',
}

export enum Tabs {
  Home = 'home',
  Menu = 'menu',
  Orders = 'orders',
}

export enum Modals {
  AddCreditCard = 'add_credit_card',
  Profile = 'profile',
  PaymentMethods = 'payment_methods',
  ManageAccount = 'manage_account',
  HelpAndFAQs = 'help_and_faqs',
  Logout = 'logout',
  OrderMethod = 'order_method',
  Location = 'location',
  DateTime = 'date_time',
  DeliveryAddress = 'delivery_address',
  Signup = 'signup',
  Login = 'login',
  MenuItem = 'menu_item',
  OrderTracker = 'order_tracker',
  RestaurantClosed = 'restaurant_closed',
  LanguageSwitcher = 'language_switcher',
}
